import ApiClient from './ApiClient';

// SICARG MOD 5 — CRUD de roles con permisos por sección.
class SicargRolesAPI extends ApiClient {
  constructor() {
    super('sicarg_roles', { accountScoped: true });
  }
}

export default new SicargRolesAPI();
